<template>
  <b-modal
    id="modal-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    title="過瀘"
    title-class="font-weight-bolder"
    headerClass="pr-3 py-2 border-bottom bgWhite"
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="sm"
  >
    <!-- <feather-icon
      @click="hide"
      style="position: absolute; right: 20px; top: 5px"
      size="18"
      icon="XIcon"
    /> -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="狀態："
              label-for="filter_worker_status"
              label-cols-md="3"
            >
              <v-select
                id="filter_worker_status"
                v-model="update.filter_worker_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="workerStatusOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇狀態"
                :filter="workerStatusSearch"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="銀行："
              label-for="filter_bank_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_bank_id"
                v-model="update.filter_bank_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="bankOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇銀行"
                :filter="bankSearch"
              >
              </v-select>
            </b-form-group>
          </b-col>

         <!--  <b-col cols="12">
            <b-form-group
              label="計薪形式："
              label-for="filter_payment_method_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_payment_method_id"
                v-model="update.filter_payment_method_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="paymentMethodStatusOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇計薪形式"
              >
              </v-select>
            </b-form-group>
          </b-col> -->
          <b-col cols="12">
            <b-form-group
              label="性別："
              label-for="filter_gender_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_gender_id"
                v-model="update.filter_gender_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="genderOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇性別"
              >
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <!-- type="reset" -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="update = {}"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            確認
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-filter");
    },
    workerStatusSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    bankSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      this.$emit("update:filter_gender_id", this.update.filter_gender_id);
      this.$emit(
        "update:filter_worker_status",
        this.update.filter_worker_status
      );
      this.$emit("update:filter_bank_id", this.update.filter_bank_id);
      this.$emit(
        "update:filter_payment_method_id",
        this.update.filter_payment_method_id
      );
      this.hide();
    },
  },
  props: {
    genderOptions: {
      type: Array,
      required: true,
    },
    bankOptions: {
      type: Array,
      required: true,
    },
    paymentMethodStatusOptions: {
      type: Array,
      required: true,
    },
    filter_gender_id: {
    },
    filter_worker_status: {
    },
    filter_bank_id: {
    },
    filter_payment_method_id: {
    },
  },
  data() {
    return {
      loading: false,
      update: {
        filter_gender_id:null,
        filter_worker_status:null,
        filter_bank_id:null,
        filter_payment_method_id:null,
      },
      workerStatusOptions:[
        {
          id: 1, name: '在職',
        },
        {
          id: 0, name: '離職',
        },
      ]
     
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
